export const data = [
    {
      id: 1,
      value: 'https://columbusenergy.pl/lp/stopka/avatary/01_2.png'
    },
    {
      id: 2,
      value: 'https://columbusenergy.pl/lp/stopka/avatary/02_2.png'
    },
    {
      id: 3,
      value: 'https://columbusenergy.pl/lp/stopka/avatary/03_2.png'
    },
    {
      id: 4,
      value: 'https://columbusenergy.pl/lp/stopka/avatary/04_2.png'
    },
    {
      id: 5,
      value: 'https://columbusenergy.pl/lp/stopka/avatary/05_2.png'
    },
    {
      id: 6,
      value: 'https://columbusenergy.pl/lp/stopka/avatary/06_2.png'
    },
    {
      id: 7,
      value: 'https://columbusenergy.pl/lp/stopka/avatary/07_2.png'
    },
    {
      id: 8,
      value: 'https://columbusenergy.pl/lp/stopka/avatary/08_2.png'
    },
    {
      id: 9,
      value: 'https://columbusenergy.pl/lp/stopka/avatary/09_2.png'
    },
    {
      id: 10,
      value: 'https://columbusenergy.pl/lp/stopka/avatary/10_2.png'
    },
    {
      id: 11,
      value: 'https://columbusenergy.pl/lp/stopka/avatary/11_2.png'
    },
    {
      id: 12,
      value: 'https://columbusenergy.pl/lp/stopka/avatary/12_2.png'
    },
    {
      id: 13,
      value: 'https://columbusenergy.pl/lp/stopka/avatary/13_2.png'
    },
    {
      id: 14,
      value: 'https://columbusenergy.pl/lp/stopka/avatary/14_2.png'
    },
    {
      id: 15,
      value: 'https://columbusenergy.pl/lp/stopka/avatary/15_2.png'
    },
    {
      id: 16,
      value: 'https://columbusenergy.pl/lp/stopka/avatary/16_2.png'
    },
];

export default data;

